export default class NavigatorService {
  static copyToClipboard(value) {
    return navigator.clipboard.writeText(value);
  }
}
